"use client";
import { useJalaliConverter } from "@/hooks/useJalaliConverter";
import { blogCard } from "@/types/BlogsType";
import Image from "next/image";
import Link from "next/link";
import Skeleton from "react-loading-skeleton";

function BlogCard({
  isLoading,
  date,
  className,
  id,
  patchImage,
  title,
  createDate,
  summery,
}: blogCard) {
  const jalaliDate = useJalaliConverter(createDate);

  return (
    <div className={`flex flex-col gap-3 w-full   ${className}`}>
      <div className=" w-full md:w-full h-48  md:h-32 lg:h-36 xl:h-48  rounded-2xl mb-4">
        {isLoading ? (
          <div className="mt-4">
            <Skeleton width={`${100}%`} height={200} borderRadius={10} />
          </div>
        ) : patchImage ? (
          <Link href={`/blogList/${id}`}>
            <Image
              src={`${patchImage}`}
              alt="food"
              width={1200}
              height={600}
              unoptimized
              className="w-full h-full object-cover rounded-2xl"
              onError={(e) => {
                e.currentTarget.src = "/images/default.png";
              }}
            />
          </Link>
        ) : (
          <Link href={`/blogList/${id}`}>
            <Image
              src="/images/default.png"
              alt="food"
              className="w-full h-full object-cover rounded-2xl"
              width={1200}
              height={6000}
              unoptimized
            />
          </Link>
        )}
      </div>
      <Link href={`/blogList/${id}`}>
        <div className="flex flex-col gap-2">
          {date ? (
            <span className="text-ws-gray-600 md:text-sm text-xs  font-medium num-vazir ">
              {jalaliDate}
            </span>
          ) : (
            ""
          )}
          <h4 className="text-ws-gray-600 md:text-base  lg:text-base text-sm">
            {title}
          </h4>
          <p className="text-ws-gray-500 line-clamp-1	md:text-sm  lg:text-sm text-xs ">
            {summery ? summery : ""}
          </p>
        </div>
      </Link>
    </div>
  );
}

export default BlogCard;
